<template>
  <main class="homePage">
    <transition name="fade-in-out">
      <confirm @close="closeConfirm" @validate="vote" v-if="confirm" :serie="series[slider_id]"></confirm>
    </transition>
      <section class="homePage__vote will-appear">
        <p class="u-color-black homePage__intro e-paragraph">
          Nous déclarons la Compétition du Festival de CANNESERIES saison 04 officiellement ouverte !<br/><br/>

          CANAL+ et ALLOCINE vous donnent l’occasion de devenir juré et de voter dès à présent parmi les 10 séries internationales sélectionnées pour décerner le Prix du Public de la Meilleure Série en Compétition.<br/><br/>

          La série gagnante sera révélée le 13 octobre lors de la Cérémonie de Clôture du Festival.
        </p>
        <p class="e-h2-canal homePage__voteText u-color-pink">Les séries en lice</p>
        <series-slider @slide="serieSlided" v-if="seriesLoaded" class="homePage__slider">
          <li v-for="serie in series" :key="serie.title" class="homePage__slide glide__slide">
            <serie-card :title="serie.name" :producer="serie.provider" :image="`${cdnUrl}/${serie.image}`"></serie-card>
          </li>
          <template v-slot:bullets>
            <div class="glide__bullets homePage__bullets" data-glide-el="controls[nav]">
              <slider-bullet v-for="(serie, i) in series" :key="i" :data-glide-dir="`=${i}`"></slider-bullet>
            </div>
          </template>
          <vote-button slot="voteButton" ref="voteButton" @click="openConfirm" :disabled="!can_vote" class="e-h4-canal homePage__button"><span>Je vote pour cette série</span></vote-button>
        </series-slider>
      </section>
  </main>
</template>
<script>
import axios from 'axios';
import Cookie from 'js-cookie';
import { mapState } from 'vuex';

import VoteButton from '../components/Elements/vote-button';
import SerieCard from '../components/components/serie-card';
import SeriesSlider from '../components/components/series-slider';
import SliderBullet from '../components/components/slider-bullet';
import Confirm from '../components/components/confirm';

export default {
  data() {
    return {
      cdnUrl: process.env.VUE_APP_CDN_BASE_URL,
      seriesLoaded: false,
      vote_id: 1,
      can_vote: false,
      slider_id: 0,
      confirm: false,
    };
  },
  components: {
    SerieCard,
    SeriesSlider,
    SliderBullet,
    VoteButton,
    Confirm,
  },
  mounted() {
    this.$store.dispatch('series/fetch').then(() => {
      this.seriesLoaded = true;
    });
  },
  computed: {
    ...mapState({
      series: state => state.series.list,
    }),
  },
  methods: {
    openConfirm() {
      this.confirm = true;
    },
    closeConfirm() {
      this.confirm = false;
    },
    async vote() {
      this.$refs.voteButton.buffering = true;
      const user_id = Cookie.get('user_id') || await axios.get(`${this.$store.state.api.baseUrl}/user/login`);
      const date = new Date();
      const midnight = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59);
      if (!Cookie.get('user_id')) Cookie.set('user_id', user_id.data.uid, { expires: midnight.toGMTString() });
      const vote_status = await axios.post(`${this.$store.state.api.baseUrl}/vote/${this.vote_id}`, {
        uid: Cookie.get('user_id'),
      });
      this.$refs.voteButton.buffering = false;
      this.confirm = false;
      window.scrollTo({
        top: window.innerHeight - 307,
        behavior: 'smooth',
      });
      if (vote_status.data.success) this.$router.push({ name: 'voted' });
      if (!vote_status.data.success) this.$store.commit('errors/add', vote_status.data.error);
    },
    serieSlided(e) {
      this.slider_id = e;
      this.vote_id = this.series[e].id;
      this.can_vote = true;
    },
  },
};
</script>

<style lang="scss">
.homePage {

  &__slider {
    grid-column: 1 / span 4;
    margin-left: -15px;
      min-width: 100vw;

    @include media('>=m') {
      grid-column: 1 / span 8;
      margin-left: -30px;
    }
  }

  &__intro,
  &__voteText {
    grid-column: 1 / span 4;

    @include media('>=m') {
      grid-column-start: 3;
      text-align: center;
    }
  }

  &__intro {
    margin-bottom: 50px;
    margin-top: 20px;

    @include media('>=m') {
      margin-top: 75px;
    }
  }

  &__voteText {
    margin-bottom: var(--spacing-m);
  }

  &__slide {
    display: flex;
    align-items: stretch;
    justify-content: center;
    cursor: grab;
  }

  &__vote {
    display: grid;
    padding: 0 15px;
    grid-template-columns: repeat(4, 1fr);
    column-gap: 15px;
    // flex-direction: column;
    // align-items: center;
    // padding-bottom: var(--spacing-m);

    @include media('>=m') {
      padding: 0 30px;
      grid-template-columns: repeat(8, 1fr);
      column-gap: 20px;
    }
  }

  // &__voteText {
  //   text-align: center;
  //   margin-bottom: var(--spacing-m);
  //   grid-column: 1 / span 4;
  //   grid-row: 1 / span 1;
  //   color: var(--color-pink);

  //   @include media('>=m') {
  //     grid-column-start: 4;
  //     text-align: left;
  //   }

  //   // &--black {
  //   //   background: var(--color-white);
  //   //   color: var(--color-black);
  //   //   padding: 5px;
  //   //   display: block;
  //   // }

  // }

  .glide__slide {
    transition: opacity .5s;

    @include media('>m') {
      opacity: 0.5;
    }

    &--active {
      opacity: 1;
    }
  }

  &__button {
    // margin-top: var(--spacing-l);
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-transform: uppercase;

    > span {
      display: flex;
      align-items: center;
      background-color: var(--color-pink);
      width: 100%;
      height: 100%;
      border-radius: 50%;
    }

    @media (hover: hover) {
      &:hover:not(:disabled) {
        color: var(--color-black);
        > span {
          background-color: var(--color-white);
        }
      }
    }
  }

  &__bullets {
    display: flex;
    justify-content: center;
  }
}
</style>
